import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";
import React, { useEffect, useRef, useState } from "react";
import { Loading } from "../../../components/Loading/Loading";
import { TabView, TabPanel } from "primereact/tabview";
import { useHistory } from "react-router-dom";
import { dataUserSession } from "../../../utilities/dataSession";
import { RadioButton } from "primereact/radiobutton";
import { InputMask } from "primereact/inputmask";
import { FooterButtonCenter } from "../../../components/FooterButton/FooterButton";
import { DialogConfirm_2, DialogShow_2, DialogConfirm, DialogViewPic } from "../../../components/DialogService/DialogService";
import { validateInputText } from "../../../utilities/ValidateUtil";
import { DialogOpenReport } from "../../../components/DialogService/DialogService";
import DialogGenReport from "../../../components/DialogReport/DialogGenReport";
import { Calendars } from "../../../components/Calendar/Calendar";
import { SelectButton } from "primereact/selectbutton";

import "./Tab.css";
import Panel_A from "./Panel_A";
import Panel_B from "./Panel_B";
import Panel_C from "./Panel_C";
import Panel_D from "./Panel_D";
import Panel_E from "./Panel_E";
import Panel_F from "./Panel_F";
import Panel_H from "./Panel_H";
import P206PicList from "./P206PicList";
import classNames from "classnames";
import P206Dialog from "./P206Dialog";

// report
import { RPT219PDF } from "../../../Report/219/RPT219PDF";
import { RPT219WORD } from "../../../Report/219/RPT219WORD";
import {
    onGetpSupervisorInspectMainInfo,
    onGetpSupervisorInspectCase1Report,
    onGetpSupervisorInspectCase2Info,
    onGetpSupervisorInspectCase3Info,
    onGetpSupervisorInspectCase4Info,
    onGetpSupervisorInspectCase5Info,
    onGetpSupervisorReport2Info,
    onGetpSupervisorReport3Info,
} from "../../../Report/219/RPT219CallService";

import {
    onP206BGetDataList,
    onP206BUpdateData,
    onP206CGetDataList,
    onP206CUpdateData,
    onP206DGetDataList,
    onP206DUpdateData,
    onP206EGetDataList,
    onP206EUpdateData,
    onP206FGetDataList,
    onP206FUpdateData,
    onP206GetDataInfo,
    onP206GetPicDataList,
    onP206UpdateClose,
    onP206UpdateData,
    onP206UpdateInspectorData,
    onExportReport,
} from "./P206_CallService";

// for test
import P206GenDialogV2 from "./P206GenDialogV2";

import ValidateService from "../../../components/ValidateService/ValidateService";
import { NullInt, NullSelect, NullString } from "../../../utilities/NullUtil";
// import Panel_G from "./Panel_G";

export default function P206() {
    const history = useHistory();
    const toast = useRef(null);

    const [errData, setErrData] = useState(null);
    const [showDialog, setShowDialog] = useState(false);
    const [textShow, setTextShow] = useState("");

    const [dialog, setDialog] = useState({ dialog: false, action: "" });
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [confirmDialog_2, setConfirmDialog_2] = useState(false);

    const [countBtnSave, setCountBtnSave] = useState(0);
    const [showCloseDialog, setShowCloseDialog] = useState(false);
    const [textShowClose, setTextShowClose] = useState("");

    const [dialogPic, setDialogPic] = useState({ dialog: false, show: false });
    const [tabCode, setTabCode] = useState("");

    // View Pic
    const [dialogViewPic, setDialogViewPic] = useState({ dialog: false, pic: "", show: false });

    //Dialog
    const [confirmDialog, setConfirmDialog] = useState(false);
    const [dialogOption, setdialogOption] = useState({
        header: "",
        content: "",
        onConfirm: () => { },
        onCancle: () => { },
        footerBtn: () => { },
    });

    //Data For Main & Panel_A
    const [searchData, setSearchData] = useState({
        requestNo: "",
        userId: dataUserSession() ? dataUserSession().userId : "",
    });
    const [formObject, setFormObject] = useState({
        backhoeCheckbox: "",
        backhoePhotoPath: "",
        contractNo: "",
        enableTab2: "",
        enableTab3: "",
        enableTab4: "",
        enableTab5: "",
        enableTab6: "",
        enableTab7: "",
        engineerCheckbox: "",
        engineerCount: "",
        engineerPhotoPath: "",
        foremanCheckbox: "",
        foremanCount: "",
        foremanName: "",
        foremanPhotoPath: "",
        foremanTelephone: "",
        inspectTime: "",
        locationBegin: "",
        locationEnd: "",
        otherCheckbox: "",
        otherPhotoPath: "",
        otherText: "",
        pipeFitterCheckbox: "",
        pipeFitterCount: "",
        pipeFitterPhotoPath: "",
        planNo: "",
        pumpCheckbox: "",
        pumpPhotoPath: "",
        requestNo: "",
        routeNo: "",
        sandCompactorCheckbox: "",
        sandCompactorPhotoPath: "",
        seqPk: "",
        truckCheckbox: "",
        truckPhotoPath: "",
        weather: "",
        workerCheckbox: "",
        workerCount: "",
        workerCountPhotoPath: "",
        requestCategory: "0",
        truckCount: "0",
        backhoeCount: "0",
        pumbCount: "0",
        sandCompactorCount: "0",
        inspectNote: "",
    });

    //Data For ผู้ปฏิบัติงาน
    const [dataPic, setDataPic] = useState([]);

    //Tab A-F
    const [dataTableA, setDataTableA] = useState([]);
    const [dataTableB, setDataTableB] = useState([]);
    const [dataTableC, setDataTableC] = useState([]);
    const [dataTableD, setDataTableD] = useState([]);
    const [dataTableE, setDataTableE] = useState([]);
    const [dataTableF, setDataTableF] = useState([]);

    const [disabledPage, setDisabledPage] = useState(false);

    // report
    const [dialogPDF, setDialogPDF] = useState(false);
    const [dialogReport, setDialogReport] = useState({ dialog: false, show: false });
    const [dataReport, setDataReport] = useState({ mainInfo: null, case1Report: null, case2Info: null, case3Info: null, case4Info: null, case5Info: null, report2Info: null, report3Info: null });

    const [dataR, setDataR] = useState({});

    const weatherOptions = [
        { label: "ปกติ", value: "1" },
        { label: "ฝนตก", value: "2" },
        { label: "ฝนตกหนัก/มีน้ำท่วมขังสถานที่ก่อสร้าง", value: "3" },
    ];

    useEffect(() => {
        if (dataUserSession()) {
            if (history.location.state) {
                setSearchData({
                    ...searchData,
                    ...history.location.state,
                });
            } else {
                history.push("/200");
            }
        } else {
            history.push("/login");
        }
    }, []);

    useEffect(() => {
        onCallMainService();
    }, [searchData]); //searchData

    useEffect(() => {
        if (formObject) {
            onP206GetPicDataList(setLoading, setDataPic, searchData, setErrData);
            if (formObject.enableTab2 && formObject.enableTab2 === "Y") {
                onP206BGetDataList(setLoading, searchData, setDataTableB, setErrData);
            }

            if (formObject.enableTab3 && formObject.enableTab3 === "Y") {
                onP206CGetDataList(setLoading, searchData, setDataTableC, setErrData);
            }

            if (formObject.enableTab4 && formObject.enableTab4 === "Y") {
                onP206DGetDataList(setLoading, searchData, setDataTableD, setErrData);
            }

            if (formObject.enableTab5 && formObject.enableTab5 === "Y") {
                onP206EGetDataList(setLoading, searchData, setDataTableE, setErrData);
            }

            if (formObject.enableTab6 && formObject.enableTab6 === "Y") {
                onP206FGetDataList(setLoading, searchData, setDataTableF, setErrData);
            }

            setDisabledPage(formObject.displayMode === "Y" ? true : false);
        }
    }, [formObject]);

    const onCallMainService = () => {
        onP206GetDataInfo(setLoading, setFormObject, setDataTableA, searchData, setErrData);
    };

    const onInputTextChange = (e, key) => {
        const val = (e.target && e.target.value) || "";
        setDataTableA({
            ...dataTableA,
            [`${key}`]: val,
        });
    };

    const footerButton = () => {
        return <FooterButtonCenter onClickCancle={() => setConfirmDialog_2(false)} onClickOk={() => submitCloseJob()} />;
    };

    const submitInspectorForm = async (submitForm) => {
        let first = {
            userId: searchData.userId,
            requestNo: searchData.requestNo,
            inspectorUserId: searchData.userId,
        };

        let newData = [];

        if (submitForm && submitForm.length > 0) {
            submitForm.forEach((item) => {
                if (item.selectFlag === "Y") {
                    newData.push({
                        userId: searchData.userId,
                        requestNo: searchData.requestNo,
                        inspectorUserId: item.inspectorUserId,
                    });
                }
            });
        }

        await onP206UpdateInspectorData(first, setLoading, setShowDialog, setTextShow, setErrData, setDataPic, searchData);

        await Promise.all(
            newData.map(async (item) => {
                await onP206UpdateInspectorData(item, setLoading, setShowDialog, setTextShow, setErrData, setDataPic, searchData);
            })
        );

        setDialog(false);
        onP206GetPicDataList(setLoading, setDataPic, searchData, setErrData);
    };

    const validationC = (object) => {
        if (object.approveFlag === null) {
            setErrData({
                text: `กรุณาระบุอนุมัติหรือไม่อนุมัติดำเนินการ`,
            });
            setSubmitted(true);
            return false;
        } else {
            setSubmitted(false);
            return true;
        }
    };
    const submitForm = async () => {
        if (validation(dataTableA) && validationC(dataTableC)) {
            let dataUpd = {
                requestNo: searchData.requestNo,
                userId: searchData.userId,
                backhoeCheckbox: NullString(dataTableA.backhoeCheckbox),
                commentBackhoe: NullSelect(dataTableA.commentBackhoe),
                commentEngineer: NullSelect(dataTableA.commentEngineer),
                commentForeman: NullSelect(dataTableA.commentForeman),
                commentOnWorker: NullString(dataTableA.commentOnWorker),
                commentOther: NullSelect(dataTableA.commentOther),
                commentPipeFitter: NullSelect(dataTableA.commentPipeFitter),
                commentPump: NullSelect(dataTableA.commentPump),
                commentSandCompactor: NullSelect(dataTableA.commentSandCompactor),
                commentTools: NullString(dataTableA.commentTools),
                engineerCheckbox: NullString(dataTableA.engineerCheckbox),
                engineerCount: NullInt(dataTableA.engineerCount),
                foremanCheckbox: NullString(dataTableA.foremanCheckbox),
                foremanCount: NullInt(dataTableA.foremanCount),
                inspectTime: NullString(dataTableA.inspectTime),
                otherCheckbox: NullString(dataTableA.otherCheckbox),
                otherText: NullString(dataTableA.otherText),
                pipeFitterCheckbox: NullString(dataTableA.pipeFitterCheckbox),
                pipeFitterCount: NullInt(dataTableA.pipeFitterCount),
                pumpCheckbox: NullString(dataTableA.pumpCheckbox),
                pumpReadyToUseCheckbox: NullString(dataTableA.pumpReadyToUseCheckbox),
                pumpStatusCheckbox: NullString(dataTableA.pumbStatusCheckbox),
                recordStamp: NullInt(dataTableA.recordStamp),
                sandCompactorCheckbox: NullString(dataTableA.sandCompactorCheckbox),
                truckCheckbox: NullString(dataTableA.truckCheckbox),
                weather: NullString(dataTableA.weather),
                workerCheckbox: NullString(dataTableA.workerCheckbox),
                workerCount: NullInt(dataTableA.workerCount),
                truckCount: NullInt(dataTableA.truckCount),
                backhoeCount: NullInt(dataTableA.backhoeCount),
                pumbCount: NullInt(dataTableA.pumbCount),
                sandCompactorCount: NullInt(dataTableA.sandCompactorCount),
                inspectNote: NullString(dataTableA.inspectNote),
            };
            // console.log(dataTableA);
            //Update Main & Tab_A

            await onP206UpdateData(dataUpd, setLoading, setShowDialog, setTextShow, setErrData);

            if (formObject.enableTab2 && formObject.enableTab2 === "Y") {
                // console.log('-----------------B');
                //     Update Tab_B
                await submitTab_B();
            }

            if (formObject.enableTab3 && formObject.enableTab3 === "Y") {
                // Update Tab_C
                // console.log('-----------------C');

                await submitTab_C();
            }

            if (formObject.enableTab4 && formObject.enableTab4 === "Y") {
                // Update Tab_D
                // console.log('-----------------D');

                await submitTab_D();
            }

            if (formObject.enableTab5 && formObject.enableTab5 === "Y") {
                // Update Tab_E
                // console.log('-----------------E');

                submitTab_E();
            }

            if (formObject.enableTab6 && formObject.enableTab6 === "Y") {
                // Update Tab_F
                // console.log('-----------------F');

                await submitTab_F();
            }

            onCallMainService();
        }
    };

    //Main & Tab_A
    const validation = (object) => {
        if ((object.weather === "" || object.weather === null || object.inspectTime === "" || object.inspectTime === null, object.approveFlag === null)) {
            setErrData({
                text: `กรอกข้อมูล ไม่ครบถ้วน `,
            });
            setSubmitted(true);
            return false;
        } else {
            setSubmitted(false);
            return true;
        }
    };

    const commentList = [
        { label: "วิศวกรสนาม", box: true, unit: true, id: "engineerCheckbox", boxid: "engineerCount", codePic: "T101", btnid: "engineerPhotoPath" },
        { label: "หัวหน้าคนงาน", box: true, unit: true, id: "foremanCheckbox", boxid: "foremanCount", codePic: "T102" },
        { label: "ช่างประกอบท่อ", box: true, unit: true, id: "pipeFitterCheckbox", boxid: "pipeFitterCount", codePic: "T103" },
        { label: "แรงงาน", box: true, unit: true, id: "workerCheckbox", boxid: "workerCount", codePic: "T104" },
        { label: "รถบรรทุก", box: true, unit: true, id: "truckCheckbox", boxid: "truckCount", codePic: "T105" },
        { label: "รถขุดดิน", box: true, unit: true, id: "backhoeCheckbox", boxid: "backhoeCount", codePic: "T106" },
        { label: "เครื่องบดอัดทราย/ดิน", box: true, unit: true, id: "sandCompactorCheckbox", boxid: "sandCompactorCount", codePic: "T107" },
        { label: "เครื่องสูบน้ำ", box: true, unit: true, id: "pumpCheckbox", boxid: "pumbCount", codePic: "T108" },
        { label: "อื่นๆ", box: true, unit: false, id: "otherCheckbox", boxid: "otherText", codePic: "T109" },
    ];

    //Tab_B
    const validation_TabB = (object) => {
        if (object.inspectResult === "" || object.inspectResult === null) {
            setErrData({
                text: `กรอกข้อมูล งานก่อสร้าง ไม่ครบถ้วน `,
            });
            setSubmitted(true);
            return false;
        } else {
            setSubmitted(false);
            return true;
        }
    };

    // const validation_TabD = (object) => {
    //     if (
    //         object.concreteCuringResult === "" ||
    //         object.concretePatternResult === "" ||
    //         object.concreteVerticalResult === "" ||
    //         object.pileInlineResult === "" ||
    //         object.pileLevelResult === "" ||
    //         object.pileStandardResult === "" ||
    //         object.pileVerticalResult === "" ||
    //         object.trussPrimerResult === "" ||
    //         object.trussStandardSteelResult === "" ||
    //         object.trussWeldResult === "" ||
    //         object.trussWeldingWireResult === ""
    //     ) {
    //         setErrData({
    //             text: `กรอกข้อมูล งานโครงสร้าง ไม่ครบถ้วน `,
    //         });
    //         setSubmitted(true);
    //         return false;
    //     } else {
    //         setSubmitted(false);
    //         return true;
    //     }
    // };

    const submitTab_B = async () => {
        dataTableB.forEach(async (obj) => {
            obj = {
                inspectId: obj.inspectId,
                inspectRemark: NullString(obj.inspectRemark),
                inspectResult: NullString(obj.inspectResult),
                requestNo: searchData.requestNo,
                userId: searchData.userId,
            };

            await onP206BUpdateData(obj, setLoading, setShowDialog, setTextShow, setErrData);
        });
    };

    const submitTab_C = async () => {
        let dataUpd = {
            beforeAsBuiltCheckbox: NullString(dataTableC.beforeAsBuiltCheckbox),
            beforeBoundaryFenceCount: NullInt(dataTableC.beforeBoundaryFenceCount),
            beforeBoundaryFenceResult: NullString(dataTableC.beforeBoundaryFenceResult),
            beforeGisCheckbox: NullString(dataTableC.beforeGisCheckbox),
            beforeInspectResult: NullString(dataTableC.beforeInspectResult),
            beforePumpCount: NullInt(dataTableC.beforePumpCount),
            beforePumpResult: NullString(dataTableC.beforePumpResult),
            closeValveTime: NullString(dataTableC.closeValveTime),
            duringBackhoeCount: NullInt(dataTableC.duringBackhoeCount),
            duringBoundaryFenceCount: NullInt(dataTableC.duringBoundaryFenceCount),
            duringBoundaryFenceResult: NullString(dataTableC.duringBoundaryFenceResult),
            duringPumpCount: NullInt(dataTableC.duringPumpCount),
            duringPumpResult: NullString(dataTableC.duringPumpResult),
            openValveTime: NullString(dataTableC.openValveTime),
            requestNo: searchData.requestNo,
            userId: searchData.userId,
            approveFlag: NullString(dataTableC.approveFlag),
            approveReason: NullString(dataTableC.approveReason),
        };

        await onP206CUpdateData(dataUpd, setLoading, setShowDialog, setTextShow, setErrData);
    };

    const submitTab_D = async () => {
        let dataUpd = {
            concreteCuringResult: NullString(dataTableD.concreteCuringResult),
            concretePatternResult: NullString(dataTableD.concretePatternResult),
            concreteVerticalResult: NullString(dataTableD.concreteVerticalResult),
            pileInlineResult: NullString(dataTableD.pileInlineResult),
            pileLevelResult: NullString(dataTableD.pileLevelResult),
            pileStandardResult: NullString(dataTableD.pileStandardResult),
            pileVerticalResult: NullString(dataTableD.pileVerticalResult),
            trussPrimerResult: NullString(dataTableD.trussPrimerResult),
            trussStandardSteelResult: NullString(dataTableD.trussStandardSteelResult),
            trussWeldResult: NullString(dataTableD.trussWeldResult),
            trussWeldingWireResult: NullString(dataTableD.trussWeldingWireResult),
            requestNo: searchData.requestNo,
            userId: searchData.userId,
        };

        // if(validation_TabD(dataUpd)){
        await onP206DUpdateData(dataUpd, setLoading, setShowDialog, setTextShow, setErrData);
        // }
    };

    const submitTab_E = async () => {
        let dataUpd = {
            feedBackResult: NullString(dataTableE.feedBackResult),
            fieldTestingResult: NullString(dataTableE.fieldTestingResult),
            repairNote: NullString(dataTableE.repairNote),
            scheduleInformResult: NullString(dataTableE.scheduleInformResult),
            testingResult: NullString(dataTableE.testingResult),
            requestNo: searchData.requestNo,
            userId: searchData.userId,
        };
        // if(validation_TabE(dataUpd)){
        await onP206EUpdateData(dataUpd, setLoading, setShowDialog, setTextShow, setErrData);
        // }
    };

    const submitTab_F = async () => {
        let dataUpd = {
            chlorineCleaningResult: NullString(dataTableF.chlorineCleaningResult),
            inspectNote: NullString(dataTableF.inspectNote),
            pressureTesingResult: NullString(dataTableF.pressureTesingResult),
            requestNo: searchData.requestNo,
            userId: searchData.userId,
        };

        // if(validation_TabE(dataUpd)){
        await onP206FUpdateData(dataUpd, setLoading, setShowDialog, setTextShow, setErrData);
        // }
    };

    const submitCloseJob = () => {
        let dataUpd = {
            ...searchData,
        };
        //Error
        setConfirmDialog_2(false);
        onP206UpdateClose(dataUpd, setLoading, setShowCloseDialog, setTextShowClose, setErrData);
    };

    const onHideCloseJob = () => {
        history.push("/200");
        setShowCloseDialog(false);
    };

    // useEffect(() => {
    // }, [dialog]);

    const onUploadDialog = (code) => {
        setDialogPic({ dialog: true, show: false, code: code });
        setTabCode(code);
    };

    const uploadPic = (code) => {
        setDialogPic({ ...dialog, dialog: true, show: true, code: code });
        setTabCode(code);
    };

    const goPage = () => {
        history.push({
            pathname: "207",
            state: {
                from: "206",
                requestNo: searchData.requestNo,
                contractNo: formObject.contractNo,
                routeNo: formObject.routeNo,
                locationBegin: formObject.locationBegin,
                locationEnd: formObject.locationEnd,
            },
        });
    };

    const contentDialog = () => {
        return (
            <div>
                <p>ต้องการปิดงานหรือไม่</p>
                <p>เมื่อปิดงานแล้วจะไม่สามารถแก้ไขรายการได้อีก !</p>
            </div>
        );
    };

    // const footerButtonCon = () => {
    //     return (
    //         <FooterButtonCustomLabel
    //             labelCon="ยืนยัน"
    //             lableCan="ยกเลิก"
    //             onClickOk={() => {
    //                 setConfirmDialog(false);
    //                 submitForm();
    //             }}
    //             onClickCancle={() => setConfirmDialog(false)}
    //         />
    //     );
    // };

    // // setting Dialog
    // const handlerSettingDialogConfirm = (key) => {
    //     switch (key) {
    //         case "SAVE":
    //             setdialogOption({
    //                 ...dialogOption,
    //                 header: "",
    //                 content: "คุณต้องการบันทึกข้อมูลหรือไม่",
    //                 footerBtn: () => footerButtonCon(),
    //                 onCancle: () => setConfirmDialog(false),
    //             });
    //             break;
    //     }

    //     setConfirmDialog({ open: true });
    // };

    // const viewImage = (event) => {
    //     setDialogViewPic({
    //         dialog: true,
    //         show: true,
    //         pic: event.photoPath,
    //     });
    // };

    const disBtnSave = () => {
        return formObject.displayMode === "Y" || countBtnSave !== 0 ? true : false;
    };
    const disBtnCloseWork = () => {
        if (formObject.displayMode === "Y") {
            return true;
        } else {
            if (countBtnSave !== 0) {
                return false;
            } else {
                return true;
            }
        }
    };

    // begin load data report

    // finish load data report

    const onExport = (act) => {
        console.log("act : ", act);
        switch (act) {
            case "PDF":
                //RPT219PDF(setLoading, setDialogPDF, dataReport);
                onExportReport("pdf", dataR, setErrData, setLoading);
                break;

            case "WORD":
                //RPT219WORD(setLoading, dataReport);
                onExportReport("docx", dataR, setErrData, setLoading);
                break;

            default:
                break;
        }
        setDialogReport({ dialog: false, show: false });
    };

    const handlerDataReport = (key, data) => {
        setDataReport((current) => ({ ...current, [key]: data }));
    };

    const handlerReport = () => {
        console.log("act : ", searchData);
        const req = {
            requestNo: searchData.requestNo,
            userId: searchData.userId,
        };
        setDataR(req);

        //load data report
        // onGetpSupervisorInspectMainInfo(setLoading, req, handlerDataReport, toast);
        // onGetpSupervisorInspectCase1Report(setLoading, req, handlerDataReport, toast);
        // onGetpSupervisorInspectCase2Info(setLoading, req, handlerDataReport, toast);
        // onGetpSupervisorInspectCase3Info(setLoading, req, handlerDataReport, toast);
        // onGetpSupervisorInspectCase4Info(setLoading, req, handlerDataReport, toast);
        // onGetpSupervisorInspectCase5Info(setLoading, req, handlerDataReport, toast);
        // onGetpSupervisorReport2Info(setLoading, req, handlerDataReport, toast);
        // onGetpSupervisorReport3Info(setLoading, req, handlerDataReport, toast);

        setDialogReport({ dialog: true, show: false });
    };

    return (
        <div>
            <Loading loading={loading} />
            <ValidateService err={errData} setErr={setErrData} />
            <Toast ref={toast} position="top-right" />
            <div className="p-grid crud-demo">
                <div className="p-col-12">
                    <div className="card">
                        <h2 className="p-m-0">บันทึกผลการตรวจงาน</h2>
                        <hr />
                        <div className="p-grid  p-fluid">
                            <div className="p-col-12 p-md-5">
                                <div className="p-grid  p-fluid" style={{ marginBottom: "10px" }}>
                                    <div className="p-col-12 p-md-6">
                                        <label>เลขที่สัญญา</label>
                                        <div className="p-inputgroup">
                                            <InputText id="contractNo" placeholder="เลขที่สัญญา" disabled value={formObject.contractNo} />
                                        </div>
                                    </div>

                                    <div className="p-col-12 p-md-6">
                                        <label>เส้นทาง</label>
                                        <div className="p-inputgroup">
                                            <InputText placeholder="เส้นทาง" id="routeName" disabled value={formObject.routeName} />
                                        </div>
                                    </div>
                                </div>
                                <div className="p-grid p-fluid" style={{ marginBottom: "10px" }}>
                                    <div className="p-col-12 p-md-6">
                                        <label>เลขที่ใบแจ้งฯ</label>
                                        <div className="p-inputgroup">
                                            <InputText placeholder="เลขที่ใบแจ้งฯ" id="requestNo" disabled value={formObject.requestNo} />
                                        </div>
                                    </div>

                                    <div className="p-col-12 p-md-6">
                                        <label>แบบแปลนเลขที่</label>
                                        <div className="p-inputgroup">
                                            <InputText placeholder="แบบแปลนเลขที่" id="planNo" disabled value={formObject.planNo} />
                                        </div>
                                    </div>
                                </div>
                                <div className="p-grid p-fluid" style={{ marginBottom: "10px" }}>
                                    <div className="p-col-12 p-md-6">
                                        <label>บริเวณก่อสร้าง</label>
                                        <div className="p-inputgroup">
                                            <InputText id="locationBegin" type="text" disabled={true} maxLength="20" value={formObject.locationBegin} />
                                            {/* <InputNumber placeholder="บริเวณก่อสร้าง" id="locationBegin" inputId="locationBegin" value={formObject.locationBegin} mode="decimal" max={99999999999} minFractionDigits={3} maxFractionDigits={3} disabled useGrouping={true} /> */}
                                        </div>
                                    </div>
                                    <div className="p-col-12 p-md-6">
                                        <label>ถึง</label>
                                        <div className="p-inputgroup">
                                            <InputText id="locationEnd" type="text" disabled={true} maxLength="20" value={formObject.locationEnd} />
                                            {/* <InputNumber placeholder="ถึง" id="locationEnd" inputId="locationEnd" value={formObject.locationEnd} mode="decimal" max={99999999999} minFractionDigits={3} maxFractionDigits={3} disabled useGrouping={true} /> */}
                                        </div>
                                    </div>
                                </div>

                                <div className="p-grid p-fluid" style={{ marginBottom: "10px" }}>
                                    <div className="p-col-12 p-md-12">
                                        <label>หัวหน้างาน</label>
                                        <div className="p-inputgroup">
                                            <InputText disabled placeholder="หัวหน้างาน" id="foremanName" value={formObject.foremanName} />
                                        </div>
                                        {/* {submitted && !formObject.telephone && validateInputText("telephone", "เบอร์ติดต่อ")} */}
                                    </div>
                                </div>

                                <div className="p-grid p-fluid" style={{ marginBottom: "10px" }}>
                                    <div className="p-col-12 p-md-12">
                                        <label>เบอร์โทรศัพท์</label>
                                        <div className="p-inputgroup">
                                            <InputText placeholder="เบอร์โทรศัพท์" id="foremanTelephone" disabled value={formObject.foremanTelephone} />
                                        </div>
                                    </div>
                                </div>

                                <div className="p-grid p-fluid" >
                                    <div className="p-col-12 p-md-12">
                                        <label htmlFor="cb1">สภาพอากาศ</label>
                                        <span style={{ color: "red" }}>*</span>
                                        <div className="flex justify-content-center">
                                            <SelectButton
                                                id="weather"
                                                optionLabel="label"
                                                options={weatherOptions}
                                                value={dataTableA.weather}
                                                onChange={(e) => onInputTextChange(e, "weather")}
                                                optionValue="value"
                                                disabled={disabledPage}
                                                className={classNames({ "p-invalid": !dataTableA.weather })} //submitted &&

                                            />
                                        </div>
                                        {/* <div className="p-field-radiobutton" style={{ marginTop: "0.45rem", marginBottom: "0.45rem" }}>
                                            <RadioButton
                                                inputId="weather_1"
                                                name="weather"
                                                value="1"
                                                onChange={(e) => onInputTextChange(e, "weather")}
                                                checked={dataTableA.weather === "1"}
                                                className={classNames({ "p-invalid": !dataTableA.weather })} //submitted &&
                                                disabled={disabledPage}
                                            />
                                            <label htmlFor="weather_1" style={{ marginRight: ".5rem" }}>
                                                ปกติ
                                            </label>
                                            <RadioButton
                                                inputId="weather_2"
                                                name="weather"
                                                value="2"
                                                onChange={(e) => onInputTextChange(e, "weather")}
                                                checked={dataTableA.weather === "2"}
                                                className={classNames({ "p-invalid": !dataTableA.weather })} //submitted &&
                                                disabled={disabledPage}
                                            />
                                            <label htmlFor="weather_2" style={{ marginRight: ".5rem" }}>
                                                ฝนตก
                                            </label>

                                            <RadioButton
                                                inputId="weather_3"
                                                name="weather"
                                                value="3"
                                                onChange={(e) => onInputTextChange(e, "weather")}
                                                checked={dataTableA.weather === "3"}
                                                className={classNames({ "p-invalid": !dataTableA.weather })} //submitted &&
                                                disabled={disabledPage}
                                            />
                                            <label htmlFor="weather_3" style={{ marginRight: ".5rem" }}>
                                                ฝนตกหนัก/มีน้ำท่วมขังสถานที่ก่อสร้าง
                                            </label>
                                        </div> */}
                                        {submitted && !dataTableA.weather && validateInputText("weather", "สภาพอากาศ")}
                                    </div>
                                </div>

                                <div className="p-grid p-fluid" style={{ marginBottom: "10px" }}>
                                    <div className="p-col-12 p-md-6">
                                        <label htmlFor="inspectTime">เวลาตรวจ</label>
                                        <span style={{ color: "red" }}>*</span>
                                        <div className="p-inputgroup flex-1">
                                            <InputMask id="inspectTime" onChange={(e) => onInputTextChange(e, "inspectTime")} className="p-invalid" mask="99:99" value={dataTableA.inspectTime} placeholder="เวลาตรวจ" disabled={disabledPage} />
                                            <Button icon="pi pi-clock" className="p-button" />
                                        </div>

                                        {/* <span className="p-input-icon-right">
                                            <InputMask id="inspectTime" onChange={(e) => onInputTextChange(e, "inspectTime")} className="p-invalid" mask="99:99" value={dataTableA.inspectTime} placeholder="เวลาตรวจ" disabled={disabledPage} />
                                            <i className="pi pi-clock" />
                                        </span> */}
                                        {submitted && !dataTableA.inspectTime && validateInputText("inspectTime", "เวลาตรวจ")}
                                    </div>
                                </div>
                            </div>
                            {/* <div className="p-col-12 p-md-1"></div> */}
                            <div className="p-col-12 p-md-7">
                                <div className="p-grid">
                                    <div className="p-col-12">
                                        {/* <label>ผู้ปฏิบัติงาน</label> */}
                                        {/* style={{ textAlign: "center" }} */}
                                        {/* <img src={require("assets/layout/images/man.jpg")} /> */}
                                        {/* <img
                                            alt="babylon-layout"
                                            src="assets/layout/images/man.jpg"
                                            style={{width:325,marginTop:20}}
                                            // style={{ width: 45, height: 56, marginTop: -12, marginLeft: -8, marginRight: 6 }}
                                        /> */}
                                        <P206PicList data={dataPic} setDialog={setDialog} disabledPage={disabledPage}></P206PicList>
                                    </div>
                                </div>
                            </div>
                            {formObject.requestCategory === "1" && (
                                <div className="p-col-12 p-md-12">
                                    <div className="card">
                                        <TabView>
                                            <TabPanel header="บันทึกแรงงานและเครื่องจักร">
                                                <Panel_A disabledPage={disabledPage} data={dataTableA} setData={setDataTableA} commentList={commentList} onUploadDialog={onUploadDialog} uploadPic={uploadPic} />
                                            </TabPanel>

                                            <TabPanel header="งานก่อสร้าง" disabled={formObject.enableTab2 === "Y" ? false : true}>
                                                <Panel_B disabledPage={disabledPage} dataTable={dataTableB} setDataTable={setDataTableB} onUploadDialog={onUploadDialog} uploadPic={uploadPic} />
                                            </TabPanel>

                                            <TabPanel header="งานตัดบรรจบ" disabled={formObject.enableTab3 === "Y" ? false : true}>
                                                <Panel_C disabledPage={disabledPage} data={dataTableC} setData={setDataTableC} onUploadDialog={onUploadDialog} uploadPic={uploadPic} />
                                            </TabPanel>

                                            <TabPanel header="งานโครงสร้าง" disabled={formObject.enableTab4 === "Y" ? false : true}>
                                                <Panel_D disabledPage={disabledPage} data={dataTableD} setData={setDataTableD} onUploadDialog={onUploadDialog} uploadPic={uploadPic} />
                                            </TabPanel>

                                            <TabPanel header="งานซ่อมคืนสภาพ" disabled={formObject.enableTab5 === "Y" ? false : true}>
                                                <Panel_E disabledPage={disabledPage} data={dataTableE} setData={setDataTableE} onUploadDialog={onUploadDialog} uploadPic={uploadPic} />
                                            </TabPanel>

                                            <TabPanel header="ระบบท่อประปา" disabled={formObject.enableTab6 === "Y" ? false : true}>
                                                <Panel_F disabledPage={disabledPage} data={dataTableF} setData={setDataTableF} onUploadDialog={onUploadDialog} uploadPic={uploadPic} />
                                            </TabPanel>

                                            {/* <TabPanel header="งานสั่งการเฉพาะอย่าง" disabled={formObject.enableTab7 === "Y" ? false : true}>
                                            <Panel_G searchData={searchData} viewImage={viewImage} />
                                        </TabPanel> */}

                                            <TabPanel header="รูปถ่ายทั้งหมด">
                                                <Panel_H searchData={searchData} data={formObject} uploadPic={uploadPic}/>
                                            </TabPanel>
                                        </TabView>
                                    </div>
                                </div>
                            )}

                            <div className="p-col-12 p-md-12">
                                <div style={{ height: "20px" }} />
                                <div className="p-grid" style={{ textAlign: "center" }}>
                                    <div className="p-col-5">
                                        <Button
                                            className="p-button p-button-success"
                                            icon="pi pi-save"
                                            label="บันทึก"
                                            style={{ width: 200, marginTop: "10px" }}
                                            onClick={() => {
                                                // handlerSettingDialogConfirm("SAVE");
                                                submitForm();
                                                setCountBtnSave(1);
                                            }}
                                            disabled={disBtnSave()}
                                        />
                                        <Button
                                            className="p-button-secondary p-button"
                                            icon="pi pi-arrow-left"
                                            label="กลับหน้าจอแสดงรายการ"
                                            // style={{ marginLeft: '5px' }}
                                            style={{ width: 200, marginLeft: "5px", marginTop: "10px" }}
                                            onClick={() => history.push("/200")}
                                        />
                                    </div>
                                    <div className="p-col-7">
                                        <Button
                                            className="p-button-help p-button"
                                            icon="pi pi-check-circle"
                                            label="ปิดงาน"
                                            // style={{ marginLeft: '5px' }}
                                            style={{ width: 200, marginLeft: "5px", marginTop: "10px" }}
                                            onClick={() => setConfirmDialog_2({ open: true })}
                                            disabled={disBtnCloseWork()}
                                        />
                                        <Button
                                            className="p-button p-button-warning"
                                            icon="pi pi-sign-in"
                                            label="งานสั่งการเฉพาะอย่าง"
                                            // style={{ marginLeft: '5px' }}
                                            style={{ width: 200, marginLeft: "5px", marginTop: "10px" }}
                                            // onClick={() => setShowAdvance(!showAdvance)}
                                            onClick={() => {
                                                goPage();
                                            }}
                                            disabled={formObject.displayMode === "Y"}
                                        />
                                        <Button
                                            className="p-button-info p-button"
                                            icon="pi pi-print"
                                            label="พิมพ์ใบสั่งสนาม"
                                            // style={{ marginLeft: '5px' }}
                                            style={{ width: 200, marginLeft: "5px", marginTop: "10px" }}
                                            onClick={() => handlerReport()}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {dialog.dialog === true ? (
                <P206Dialog
                    dialog={dialog}
                    setDialog={setDialog}
                    submitForm={(e) => submitInspectorForm(e)}
                    data={dataPic}
                    setData={setDataPic}
                //submitted={submitted}
                />
            ) : (
                ""
            )}
            <DialogConfirm visible={confirmDialog.open} header={dialogOption.header} modal footer={dialogOption.footerBtn} onHide={() => setConfirmDialog(false)} textContent={dialogOption.content} />
            <DialogConfirm_2 visible={confirmDialog_2.open} header="แจ้งเตือน" modal footer={footerButton()} onHide={() => setConfirmDialog_2(false)} textContent={contentDialog()} />

            <DialogShow_2 visible={showDialog} header="แจ้งเตือน" modal onHide={() => setShowDialog(false)} className="p-fluid" textContent={textShow} btnCancle={() => setShowDialog(false)} />

            <DialogShow_2 visible={showCloseDialog} header="แจ้งเตือน" modal onHide={() => onHideCloseJob()} className="p-fluid" textContent={textShowClose} btnCancle={() => onHideCloseJob()} />

            {/* <P206GenDialog dialog={dialogPic} setDialog={setDialogPic} searchData={searchData} tabCode={tabCode} /> */}
            <P206GenDialogV2 dialog={dialogPic} setDialog={setDialogPic} searchData={searchData} tabCode={tabCode} />
            <DialogViewPic dialog={dialogViewPic} data={dialogViewPic.pic} modal setDialogPic={setDialogViewPic} />

            {/*report*/}
            <DialogGenReport dialog={dialogReport} setDialog={setDialogReport} setExport={onExport} pdf={true} word={true} setHeader="พิมพ์ใบสั่งสนาม" />
            <DialogOpenReport header="พิมพ์ใบสั่งสนาม" dialog={dialogPDF} setDialog={setDialogPDF} />
        </div>
    );
}
